/*
 * reducer.js
 */

import {RECEIVE_QUOTE} from '../Action/action'
import {combineReducers} from 'redux'
import * as asyncInitialState from 'redux-async-initial-state';


 function currentQuote(state = {}, action){
    switch (action.type){
        case RECEIVE_QUOTE:
            return Object.assign({},state, {
                currentQuote: action.data
            })
        default:
            return state
    } 
    

 }
export const appState = asyncInitialState.outerReducer(combineReducers({
    currentQuote,
    asyncInitialState: asyncInitialState.innerReducer,
}));



// WEBPACK FOOTER //
// ./src/Reducer/reducer.js